// Single source of truth for the 12-mood daily check-in set. Each mood is
// a custom hand-drawn SVG face (see MoodFace), with a light and a deep
// colour, a warm one-line echo, an idle animation, and a 1..5 score so the
// week-by-week strip shares one source of truth. A mood is stored as a free
// string on a note and never affects any assessment score.
export const MOODS = [
  { key: "relief",   label: "relief",   c1: "#8FE8C4", c2: "#22A77A", echo: "exhale. you earned it.",   score: 5, anim: "floaty",  dur: 3.2 },
  { key: "onone",    label: "on one",   c1: "#FFC98A", c2: "#F0872E", echo: "lock in, quietly.",        score: 4, anim: "flamey",  dur: 1.6 },
  { key: "chill",    label: "chill",    c1: "#8FBAF4", c2: "#2E6BD6", echo: "cruising is valid.",       score: 4, anim: "swayy",   dur: 4 },
  { key: "melting",  label: "melting",  c1: "#FFCE93", c2: "#EE8A2E", echo: "too much at once, noted.", score: 2, anim: "droopy",  dur: 3.4 },
  { key: "cooked",   label: "cooked",   c1: "#CBB2F7", c2: "#8B5CF6", echo: "fried is honest.",         score: 1, anim: "sinky",   dur: 3.4 },
  { key: "rough",    label: "rough",    c1: "#C0AEF0", c2: "#7A5BD6", echo: "rough is okay to name.",   score: 2, anim: "sinky",   dur: 3 },
  { key: "thriving", label: "thriving", c1: "#8FE8A8", c2: "#33B36B", echo: "soak it up.",              score: 5, anim: "floaty",  dur: 2.4 },
  { key: "soft",     label: "soft",     c1: "#FFC2DB", c2: "#F06AA0", echo: "be gentle with you.",      score: 4, anim: "beaty",   dur: 2.2 },
  { key: "meh",      label: "meh",      c1: "#D2D6E2", c2: "#8B90A6", echo: "flat days count too.",     score: 3, anim: "swayy",   dur: 6 },
  { key: "salty",    label: "salty",    c1: "#FFA594", c2: "#E8492E", echo: "let it out here.",         score: 2, anim: "jittery", dur: 0.4 },
  { key: "drained",  label: "drained",  c1: "#C7C8EC", c2: "#6E70A6", echo: "rest is data too.",        score: 2, anim: "droopy",  dur: 3.6 },
  { key: "shambles", label: "shambles", c1: "#A6BDF2", c2: "#3E63C8", echo: "you still showed up.",     score: 1, anim: "swayy",   dur: 5 },
];

// `color` mirrors the deep stop so the week-by-week strip and legend can
// read a single field (this preserves the MoodTrend contract).
MOODS.forEach((m) => { m.color = m.c2; });

export const MOOD_BY_KEY = Object.fromEntries(MOODS.map((m) => [m.key, m]));

// The moods that read as a hard day. Three logged in a row trips the
// gentle care rail in the journal. Legacy "worse" is kept so older notes
// still count toward it.
export const DOWN_MOODS = ["cooked", "shambles", "rough", "drained", "worse"];

// A light card tint in a mood's own colour: a faint wash, a soft border,
// and the deep colour as the accent bar. Used so each note reads in the
// colour of how it felt.
export function moodTint(key) {
  const m = MOOD_BY_KEY[key];
  if (!m) return null;
  return { bg: `${m.c2}14`, border: `${m.c2}33`, bar: m.c2 };
}
